import { render, staticRenderFns } from "./NotificationActionButtons.vue?vue&type=template&id=11471b4c&scoped=true&"
import script from "./NotificationActionButtons.vue?vue&type=script&lang=js&"
export * from "./NotificationActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./NotificationActionButtons.vue?vue&type=style&index=0&id=11471b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11471b4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardActions,
  VIcon,
  VSpacer,
  VTooltip,
})
